import { CircularProgress, Backdrop } from "@mui/material";

export const Cargando = ({ open = false }) => {
    return (
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => 20001 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  };
  